const BASE_URL = "https://crew.clikkle.com:4000";

export default BASE_URL;
